export default __webpack_public_path__ + "static/media/message.1ce54e56.svg";